import script from "./Panel.vue?vue&type=script&setup=true&lang=js"
export * from "./Panel.vue?vue&type=script&setup=true&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=24ab76cc&lang=stylus"

const __exports__ = script;

export default __exports__